import {
  Avatar,
  Box,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Skeleton,
} from '@mui/material';
import {
  SchedulingProps,
  SchedulingWarningsProps,
} from '../SchedulingInterface';
import { useEffect, useState } from 'react';
import { styles } from './styles';
import { AppError } from '@/utils/AppError';
import { usePatientService } from '@/data/services/schedule/usePatientService';
import { PatientDTO } from '@/data/DTOs/schedule/PatientDTO';
import { getFirstLastLetter } from '@/utils/getFirstLastLetter';
import { ScheduleDTO } from '@/data/DTOs/schedule/ScheduleDTO';
import { useAuthStore } from '@/stores/AuthStore';

export const SchedulingListUser = ({
  setSchedule,
  schedule,
  setLoading,
  setShowWarning,
  setWarningMessage,
  setIsValid,
  internalObject,
  setInternalObject,
}: SchedulingProps & SchedulingWarningsProps) => {
  const [patients, setPatients] = useState<PatientDTO[]>([]);
  const { getPatientsList } = usePatientService();

  const { user } = useAuthStore();
  const skeletonItems = Array.from(new Array(5));

  useEffect(() => {
    fetchPatients();
  }, []);

  useEffect(() => {
    setIsValid(internalObject.patientName != '');
  }, [internalObject.patientName]);

  const fetchPatients = async () => {
    setLoading(true);
    getPatientsList()
      .then((patients) => {
        setPatients(patients);
      })
      .catch((error: AppError) => {
        setWarningMessage(error.message);
        setShowWarning(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const getUpdatedSchedule = (
    prev: ScheduleDTO,
    patient: PatientDTO,
    userId?: string
  ): ScheduleDTO => {
    return {
      ...prev,
      subId: patient.id,
      userDependentId: patient.id !== userId ? patient.id : undefined,
    };
  };

  const item = (patient: PatientDTO, index: number) => {
    return (
      <ListItemButton
        disabled={patient.reachedAgeMajority && patient.reachedAgeMajority}
        sx={[
          styles.item,
          schedule.subId === patient.id
            ? styles.itemFocused
            : styles.itemNotFocused,
        ]}
        key={index}
        selected={schedule.subId === patient.id}
        onClick={() => {
          const updatedSchedule = getUpdatedSchedule(
            schedule,
            patient,
            user?.id
          );
          setSchedule(updatedSchedule);
          setInternalObject({
            ...internalObject,
            patientName: patient.name + ' ' + patient.surname,
            patientPhoto: patient.profilePhotoUrl ?? '',
          });
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt={patient.name}
            src={patient.profilePhotoUrl}
            sx={styles.photo}
          >
            {getFirstLastLetter(patient.name, patient.surname)}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={`${patient.name} ${patient.surname}`}
          sx={styles.titleCard}
        />
      </ListItemButton>
    );
  };

  return (
    <List sx={styles.list}>
      {patients.length === 0
        ? skeletonItems.map((_, index) => (
            <Box key={index} sx={{ position: 'relative', mb: 1 }}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={70}
                sx={{ border: '1px solid #ccc', borderRadius: 1 }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: 8,
                  left: 16,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Skeleton variant="circular" width={50} height={50} />
                <Skeleton
                  variant="text"
                  width={120}
                  height={20}
                  sx={{ ml: 2 }}
                />
              </Box>
            </Box>
          ))
        : patients.map((patient: PatientDTO, index) => item(patient, index))}
    </List>
  );
};
